import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import TierConsumerReduxModule from '../../Tier/redux/consumer/ModuleLoadable';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import SubscribeVariant from './variants/Subscribe';
import ExploreVariant from './variants/Explore';
import SubscribedVariant from './variants/Subscribed';
import ViewVariant from './variants/View';
import DisabledVariant from './variants/Disabled';
import s from './SubscribeButton.scss';
var SubscribeButton = function (_a) {
    var tier = _a.tier, _b = _a.tier.tier, _c = _b === void 0 ? {} : _b, isUserSubscribed = _c.isUserSubscribed, canUserSubscribe = _c.canUserSubscribe, type = _a.type, withPrice = _a.withPrice, showUnsubAsView = _a.showUnsubAsView, className = _a.className, href = _a.href, size = _a.size, onSubscribe = _a.onSubscribe, onUnsubscribe = _a.onUnsubscribe, reduxReady = _a.reduxReady, matureFilterOverridden = _a.matureFilterOverridden, matureFilterDisabled = _a.matureFilterDisabled;
    var showBlocked = useDeviationMatureFilter(tier).showBlocked;
    var waitingAction = useRef();
    var _d = useState(false), loadRedux = _d[0], setLoadRedux = _d[1];
    useEffect(function () {
        if (reduxReady && waitingAction.current) {
            waitingAction.current();
            waitingAction.current = undefined;
        }
    }, [reduxReady]);
    useEffect(function () {
        if (showBlocked && !matureFilterDisabled && !matureFilterOverridden) {
            setLoadRedux(true);
        }
    }, [showBlocked, matureFilterDisabled, matureFilterOverridden]);
    // TODO: this (or the ds button itself) really needs a focus-visible ring
    var renderViewVariant = function () { return (React.createElement(ViewVariant, { tier: tier, className: cn(className, s['centered']), size: size })); };
    var renderSubscribeVariant = function () { return (React.createElement(SubscribeVariant, { tier: tier, className: className, withPrice: withPrice, href: href, size: size, onSubscribe: function (t) {
            if (!reduxReady) {
                waitingAction.current = function () {
                    onSubscribe && onSubscribe(t);
                };
                setLoadRedux(true);
                return;
            }
            onSubscribe && onSubscribe(t);
        } })); };
    var renderExploreVariant = function () { return (React.createElement(ExploreVariant, { tier: tier, className: className, withPrice: withPrice, href: href, size: size, onSubscribe: function (t) {
            if (!reduxReady) {
                waitingAction.current = function () {
                    onSubscribe && onSubscribe(t);
                };
                setLoadRedux(true);
                return;
            }
            onSubscribe && onSubscribe(t);
        } })); };
    var renderSubscribedVariant = function () { return (React.createElement(SubscribedVariant, { tier: tier, className: cn(className, s['centered'], s['unsubscribe-width']), href: href, size: size })); };
    var renderDisabledVariant = function () { return (React.createElement(DisabledVariant, { className: cn(className, s['centered']), size: size })); };
    var buttonElement;
    if (type) {
        switch (type) {
            case 'view':
                buttonElement = renderViewVariant();
                break;
            case 'subscribe':
                buttonElement = renderSubscribeVariant();
                break;
            case 'explore':
                buttonElement = renderExploreVariant();
                break;
            case 'subscribed':
                buttonElement = renderSubscribedVariant();
                break;
            case 'disabled':
                buttonElement = renderDisabledVariant();
                break;
            default:
                break;
        }
    }
    else {
        if (isUserSubscribed) {
            if (showUnsubAsView) {
                buttonElement = renderViewVariant();
            }
            else {
                buttonElement = renderSubscribedVariant();
            }
        }
        else if ((showBlocked && !matureFilterDisabled && !matureFilterOverridden) ||
            !canUserSubscribe) {
            buttonElement = renderDisabledVariant();
        }
        else {
            buttonElement = renderSubscribeVariant();
        }
    }
    return (React.createElement(React.Fragment, null,
        loadRedux && React.createElement(TierConsumerReduxModule, null),
        buttonElement));
};
SubscribeButton.displayName = 'SubscribeButton';
export default SubscribeButton;
//# sourceMappingURL=SubscribeButton.js.map